<template>
  <div class="box1">
    <div class="detail">
      <div class="header">
        <div
          class="header_title"
          :class="{
            headerActive: idx === index,
            headerRight: idx === 1,
            headerLeft: idx === 0,
          }"
          @click="addClass(item, idx)"
          v-for="(item, idx) in menu"
          :key="idx"
        >
          {{ item }}
        </div>
      </div>
      <div class="content2" v-show="flag">
        <div class="content_one" v-if="splitInfo.orgName">
          <div class="content_left">申请机构</div>
          <div class="content_right">{{ splitInfo.orgName }}</div>
        </div>
        <div class="content_one" v-if="splitInfo.userName">
          <div class="content_left">操作人</div>
          <div class="content_right">{{ splitInfo.userName }}</div>
        </div>
        <div class="content_one" v-if="splitInfo.content">
          <div class="content_left">拆单原因</div>
          <div class="content_right">{{ splitInfo.content }}</div>
        </div>
        <div class="content_one" v-if="oriList.orgName">
          <div class="content_left">转办机构</div>
          <div class="content_right">{{ oriList.orgName }}</div>
        </div>
        <div class="content_one" v-if="oriList.userName">
          <div class="content_left">操作人</div>
          <div class="content_right">{{ oriList.userName }}</div>
        </div>
        <div class="content_one" v-if="oriList.content">
          <div class="content_left">办理要求</div>
          <div class="content_right">{{ oriList.content }}</div>
        </div>

        <div
          class="content_one"
          v-if="sendInfo.reportDetails && sendInfo.reportDetails.orgName"
        >
          <div class="content_left">上报机构</div>
          <div class="content_right">{{ sendInfo.reportDetails.orgName }}</div>
        </div>
        <div
          class="content_one"
          v-if="sendInfo.reportDetails && sendInfo.reportDetails.userName"
        >
          <div class="content_left">操作人</div>
          <div class="content_right">{{ sendInfo.reportDetails.userName }}</div>
        </div>
        <div
          class="content_one"
          v-if="sendInfo.reportDetails && sendInfo.reportDetails.content"
        >
          <div class="content_left">上报原因</div>
          <div class="content_right">{{ sendInfo.reportDetails.content }}</div>
        </div>
        <div class="content_one_img">
          <div class="content_left">上报证据</div>
          <div
            class="content_img"
            v-if="
              sendInfo.reportDetails &&
              sendInfo.reportDetails.urls &&
              sendInfo.reportDetails.urls.length > 0
            "
          >
            <img
              :src="item"
              v-for="(item, index) in sendInfo.reportDetails.urls"
              :key="index"
              @click="showViewer(index, $event, sendInfo.reportDetails.urls)"
              alt
            />
          </div>
        </div>
        <div class="content_one">
          <div class="content_left">投诉对象</div>
          <div class="content_right">{{ baseInfo.defendantName }}</div>
        </div>
        <div class="content_one">
          <div class="content_left">投诉单号</div>
          <div class="content_right">{{ baseInfo.mainComplainNumber }}</div>
        </div>
        <div class="content_one">
          <div class="content_left">投诉类型</div>
          <div class="content_right">{{ baseInfo.complainChannelValue }}</div>
        </div>
        <div class="content_one">
          <div class="content_left">投诉时间</div>
          <div class="content_right">{{ baseInfo.complainTime }}</div>
        </div>
        <div class="content_one">
          <div class="content_left">投诉人</div>
          <div class="content_right">{{ baseInfo.complainName }}</div>
        </div>
        <div class="content_one" v-if="baseInfo.complainPhone">
          <div class="content_left">联系电话</div>
          <div class="content_right">{{ baseInfo.complainPhone }}</div>
        </div>
        <div class="content_one" v-if="baseInfo.isHiddenVirtual">
          <div class="content_left">政府专用号</div>
          <div
            class="content_icon"
            v-if="!baseInfo.governmentVirtualNumber"
            @click="getPhone(0)"
          >
            获取
          </div>
          <div
            class="content_right"
            v-if="baseInfo.governmentVirtualNumber"
            @click="playPhone(baseInfo.governmentVirtualNumber)"
          >
            <div class="content_right_parent_content">
              {{ baseInfo.governmentVirtualNumber }}
            </div>
          </div>
        </div>
        <div class="content_one" v-if="!baseInfo.isHiddenVirtual">
          <!-- <div class="content_one" v-if="unitType === 'enterprise' && !baseInfo.is_hidden_virtual"> -->
          <div class="content_left">企业专用号</div>
          <div
            class="content_icon"
            v-if="!baseInfo.enterpriseVirtualNumber"
            @click="getPhone(1)"
          >
            获取
          </div>
          <div class="content_right" v-if="baseInfo.enterpriseVirtualNumber">
            <div
              class="content_right_parent_content"
              @click="playPhone(baseInfo.enterpriseVirtualNumber)"
            >
              {{ baseInfo.enterpriseVirtualNumber }}
            </div>
          </div>
        </div>
        <div class="content_one">
          <div class="content_left">身份证</div>
          <div class="content_right">
            {{ baseInfo.complainPaperworkNumber }}
          </div>
        </div>
        <div class="content_one">
          <div class="content_left">事发地</div>
          <div class="content_right">{{ baseInfo.incidentBefallCityName }}</div>
        </div>
        <!-- <div class="content_one">
          <div class="content_left">投诉原因</div>
          <p class="content_right content_right1">{{baseInfo.complainContent}}</p>
        </div> -->
        <div class="content_reson">
          <div class="content_left">投诉原因</div>
          <p class="content_right content_right1">
            {{ baseInfo.complainContent }}
          </p>
        </div>
        <div class="content_one">
          <div class="content_left">投诉诉求</div>
          <div class="content_right">{{ baseInfo.complainRequest }}</div>
        </div>
        <div class="content_one_img">
          <div class="content_left">相关证据</div>
          <div
            class="content_img"
            v-if="
              baseInfo &&
              baseInfo.attachmentList &&
              baseInfo.attachmentList.length > 0
            "
          >
            <img
              :src="item"
              alt
              v-for="(item, index) in baseInfo.attachmentList"
              :key="index"
              @click="showViewer(index, $event, baseInfo.attachmentList)"
            />
          </div>
        </div>
        <div class="content_one_img">
          <div class="content_left">补充证据</div>
          <div
            class="content_img"
            v-if="baseInfo.supplementList && baseInfo.supplementList.length > 0"
          >
            <img
              :src="item"
              v-for="(item, index) in baseInfo.supplementList"
              :key="index"
              @click="showViewer(index, $event, baseInfo.supplementList)"
              alt
            />
          </div>
        </div>
        <div class="content_one_img">
          <div class="content_left">附件证据</div>
          <div
            class="content_img1"
            v-if="
              baseInfo.platform12301List &&
              baseInfo.platform12301List.length > 0
            "
          >
            <div
              class="item"
              v-for="(item, index) in baseInfo.platform12301List"
              :key="index"
            >
              <img
                src="../../../../assets/complaint/Group 2.png"
                @click="downGazp(item)"
                alt
              />
              <p class="name">{{ item | filt }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!flag" class="con_details">
        <div class="detail_top line_bottom">
          <div class="detail_top_title">
            游客评价
            <span class="special">(游客对整个投诉单的评价)</span>
          </div>
          <div class="detail_top_content">{{ baseInfo.evaluationContent }}</div>
        </div>
        <ul class="detail_list" @click.stop>
          <li class="detail_li" v-for="(item, index) in detaiList" :key="index">
            <!-- 调整后 -->
            <div
              v-if="
                item.version == 2 &&
                userInfo.userInfo.orgType.indexOf('company') <= -1
              "
            >
              <div class="detail_li_top">
                <div class="detail_li_title" v-if="item.handleOrgName">
                  处理区域：{{ item.handleOrgName }}
                </div>
                <!-- <div class="detail_li_title">
                  投诉处置反馈
                </div> -->
                <div :class="`detail_li_title_tag ${sstt[item.emergency == '' ? '': Number(item.emergency-7)]}`">{{ item.emergencyValue }}</div>
              </div>
              <div class="detail_li_content">
                <div class="detail_li_content_one">
                  <div class="detail_li_content_left">
                    对象分类：{{ item.complainObject }}
                  </div>
                  <div class="detail_li_content_left">
                    工单分类：{{ item.ordertypeValue }}
                  </div>
                </div>
                <div class="detail_li_content_one">
                  <!-- <div class="detail_li_content_left">紧急程度：{{item.emergencyValue}}</div> -->
                  <div class="detail_li_content_left">
                    投诉分类：{{ item.complainClassify }}
                  </div>
                  <div class="detail_li_content_left">
                    具体情形：{{ item.specificSituation }}
                  </div>
                </div>
                <div class="detail_li_content_one">
                  <div class="detail_li_content_left">
                    处理时长：{{ item.complainEndLong | filt1 }}
                  </div>
                  <div class="detail_li_content_left">
                    办结时限：{{ item.implementationDuration | filt3 }}
                  </div>
                </div>
                <!-- <div class="detail_li_content_one">
                  <div class="detail_li_content_left">处理时长：{{item.complainEndLong|filt1}}</div>
                </div>
                <div class="detail_li_content_one">
                  <div class="detail_li_content_left">办结时长：{{item.implementationDuration|filt3}}</div>
                </div> -->
              </div>
            </div>
            <div
              v-if="
                item.version == 2 &&
                userInfo.userInfo.orgType.indexOf('company') > -1
              "
            >
              <div class="detail_li_top">
                <div class="detail_li_title">投诉处置反馈</div>
              </div>
              <div class="detail_li_content">
                <div class="detail_li_content_one">
                  <div class="detail_li_content_left">
                    处理时长：{{ item.complainEndLong | filt1 }}
                  </div>
                  <div class="detail_li_content_left">
                    办结时长：{{ item.implementationDuration | filt3 }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 调整前 -->
            <div v-if="item.version == 1">
              <div class="detail_li_top">
                <div class="detail_li_title">
                  处理区域：{{ item.handleOrgName }}
                </div>
                <div class="detail_li_button">
                  <span class="btn" v-show="false">超时</span>
                  <span class="btn1" v-show="!false"></span>
                  <span class="ordinary" v-show="item.emergency == 7"
                    >一般</span
                  >
                  <span class="discharge" v-show="item.emergency == 8"
                    >较重</span
                  >
                  <span class="serious" v-show="item.emergency == 9">严重</span>
                </div>
              </div>
              <div class="detail_li_content">
                <div class="detail_li_content_one">
                  <div class="detail_li_content_left">
                    对象分类：{{ item.complainObject }}
                  </div>
                  <div class="detail_li_content_right">
                    工单分类:{{ item.ordertypeValue }}
                  </div>
                </div>
                <div class="detail_li_content_one">
                  <div class="detail_li_content_left">
                    投诉分类：{{ item.complainClassify }}
                  </div>
                  <div class="detail_li_content_right">
                    具体情形：{{ item.specificSituation }}
                  </div>
                </div>
                <div class="detail_li_content_one">
                  <div class="detail_li_content_left">
                    处理时长：{{ item.complainEndLong | filt1 }}
                  </div>
                  <div class="detail_li_content_right">
                    办结时限：{{ item.implementationDuration | filt3 }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="detail_li_result"
              v-show="!item.flag"
              v-for="(i, code) in item.dealDetails"
              :key="code"
            >
              <div v-if="item.version == 2">
                <div class="detail_li_result_top">
                  <div class="detail_li_result_top_left">
                    <!-- <i v-if="i.supplementType==1||i.supplementType==2||i.supplementType==3||i.supplementType==4">投诉办结反馈</i> -->
                    <i>{{ i.operateTypeValue }}</i>
                    <i v-if="i.type && i.type == 5">{{ i.typeValue }}</i>
                  </div>
                  <div class="detail_li_result_top_right">
                    {{ i.createTime }}
                  </div>
                </div>
                <!-- 调整后 -->
                <!-- <div class="detail_li_result_top">s
                  <div class="detail_li_result_top_left">
                      <span>{{ i.operateOrgName }}</span>
                  </div>
                </div> -->
                <div class="detail_li_result_top">
                  <div class="detail_li_result_top_left">
                    <span style="color: #000">{{
                      i.operateOrgName && i.operateOrgName.length > 8
                        ? i.operateOrgName.slice(0, 8) + "..."
                        : i.operateOrgName
                    }}</span>
                    <span class="title_color" v-if="i.supplementType == 1"
                      >[自行和解]</span
                    >
                    <span class="title_color" v-if="i.supplementType == 2"
                      >[调解成功]</span
                    >
                    <span class="title_color" v-if="i.supplementType == 3"
                      >[调解失败]</span
                    >
                    <span class="title_color" v-if="i.supplementType == 4"
                      >[启用质保金赔偿]</span
                    >
                    <span v-if="i.type && i.type == 5">{{
                      i.feedbackOrgName
                    }}</span>
                  </div>
                  <!-- <div class="detail_li_result_top_right">
                      {{i.createTime}}
                  </div> -->
                </div>
                <div class="detail_li_result_top" v-if="i.supplementType != 3">
                  <div
                    class="detail_li_result_top_left detail_li_result_name"
                    style="color: #333"
                  >
                    <i
                      v-if="
                        i.supplementType == 1 ||
                        i.supplementType == 4 ||
                        i.supplementType == 2
                      "
                      >退货、退款：{{ i.refundAmount }}元</i
                    >
                  </div>
                  <div
                    class="detail_li_result_top_right"
                    v-if="i.product !== -1 && i.type != 5"
                    style="color: #333"
                  >
                    服务质量赔偿：<i v-if="i.supplementType == 6">{{
                      i.fulfillPlace
                    }}</i
                    ><i
                      v-if="
                        i.supplementType == 1 ||
                        i.supplementType == 4 ||
                        i.supplementType == 2
                      "
                      >{{ i.amount }}元</i
                    >
                  </div>
                </div>
                <div
                  class="detail_li_result_content"
                  v-if="i.type && i.type != 5"
                >
                  <i>办结时间:{{ i.complainEndTime }}</i>
                </div>
                <div
                  class="detail_li_result_content"
                  v-if="i.supplementType == 1 || i.supplementType == 3"
                >
                  <i>{{ i.remark }}</i>
                </div>
                <div
                  class="detail_li_result_content"
                  v-if="i.supplementType == 2 || i.supplementType == 4"
                >
                  <i
                    ><div>事实经过:</div>
                    {{ i.realSituation }}</i
                  >
                </div>
                <div
                  class="detail_li_result_content"
                  v-if="i.supplementType == 2"
                >
                  <i
                    ><div>调解备注:</div>
                    {{ i.agreement }}</i
                  >
                </div>
                <div
                  class="detail_li_result_content"
                  v-if="i.supplementType == 4"
                >
                  <i
                    ><div>调解备注:</div>
                    {{ i.remark }}</i
                  >
                </div>
                <div
                  class="detail_li_result_content"
                  v-if="i.type && i.type == 5"
                >
                  <i
                    ><div>补充内容:</div>
                    {{ i.feedbackContent }}</i
                  >
                </div>
                <div class="content_img" v-if="i.type && i.type == 5">
                  <img
                    :src="j"
                    v-for="(j, currentIndex2) in i.url"
                    :key="currentIndex2"
                    @click="showViewer1(currentIndex2, $event, i.url)"
                    alt
                  />
                </div>
                <div
                  class="detail_li_content_score"
                  v-if="i.score && i.score != -1"
                >
                  <div stlye="color:#000;">
                    游客评分：
                    <span v-if="i.score === 3">满意</span>
                    <span v-if="i.score === 2">基本满意</span>
                    <span v-if="i.score === 1">不满意</span>
                  </div>
                  <img
                    src="../../../../assets/image/happy.png"
                    v-show="i.score === 3"
                    alt
                  />
                  <img
                    src="../../../../assets/image/norCopy.png"
                    v-show="i.score === 2"
                    alt
                  />
                  <img
                    src="../../../../assets/image/unhappy.png"
                    v-show="i.score === 1"
                    alt
                  />
                </div>
                <div class="content_img">
                  <img
                    :src="j.url"
                    v-for="(j, currentIndex2) in i.imgUrl"
                    :key="currentIndex2"
                    @click="showViewer2(currentIndex2, $event, i.imgUrl)"
                    alt
                  />
                </div>
                <div
                  class="content_img"
                  v-if="i.fileUrl && i.fileUrl.length > 0"
                >
                  <div
                    class="file_img"
                    v-for="(s, index) in i.fileUrl"
                    :key="index"
                  >
                    <span>{{ s.url }}</span>
                    <span @click="downGazp(s.url)">下载</span>
                  </div>
                </div>
              </div>
              <!-- 调整前 -->
              <div v-if="item.version == 1">
                <div class="detail_li_result_top">
                  <div class="detail_li_result_top_left">
                    <span v-if="i.type === 3">企业处置结果</span>
                    <span v-if="i.type === 2">部门处置结果</span>
                    <span v-if="i.type === 1">指挥中心处置结果</span>
                    <span v-if="i.type === 12">企业处置结果</span>
                    <span v-if="i.type === 11">部门处置结果</span>
                    <span v-if="i.type === 10">指挥中心处置结果</span>
                    <span v-if="i.type === 5">补充办结材料</span>
                  </div>
                  <div class="detail_li_result_top_right">
                    {{ i.createTime }}
                  </div>
                </div>
                <div class="detail_li_result_top">
                  <div
                    class="detail_li_result_top_left detail_li_result_name"
                    style="color: #333"
                  >
                    {{ i.feedbackOrgName }}&nbsp;
                  </div>
                  <div
                    class="detail_li_result_top_left detail_li_result_success"
                    v-if="i.resultType == 1"
                  >
                    [协商成功]
                  </div>
                  <div
                    class="detail_li_result_top_left detail_li_result_defeated"
                    v-if="i.resultType == 2"
                  >
                    [协商失败]
                  </div>
                  <div
                    class="detail_li_result_top_left detail_li_result_success"
                    v-if="i.resultType == 3"
                  >
                    [调解成功]
                  </div>
                  <div
                    class="detail_li_result_top_left detail_li_result_defeated"
                    v-if="i.resultType == 4"
                  >
                    [调解失败]
                  </div>
                  <div
                    class="detail_li_result_top_right"
                    v-if="i.product !== -1 && i.type != 5"
                    style="color: #333"
                  >
                    赔偿金额：{{ i.product }}元
                  </div>
                </div>
                <div class="detail_li_result_content">
                  <i>{{ i.feedbackContent }}</i>
                </div>
                <div class="content_img">
                  <img
                    :src="item1"
                    alt
                    v-for="(item1, currentIndex1) in i.url"
                    :key="currentIndex1"
                    @click="showViewer1(i, currentIndex1)"
                  />
                </div>
                <div
                  class="detail_li_content_score"
                  v-if="i.score && i.score != -1"
                >
                  <div>
                    游客评分：
                    <span v-if="i.score === 3">满意</span>
                    <span v-if="i.score === 2">基本满意</span>
                    <span v-if="i.score === 1">不满意</span>
                  </div>
                  <img
                    src="../../../../assets/image/happy.png"
                    v-show="i.score === 3"
                    alt
                  />
                  <img
                    src="../../../../assets/image/norCopy.png"
                    v-show="i.score === 2"
                    alt
                  />
                  <img
                    src="../../../../assets/image/unhappy.png"
                    v-show="i.score === 1"
                    alt
                  />
                </div>
              </div>
            </div>

            <div
              class="detail_li_returnResult"
              @click="item.flag = !item.flag"
              v-show="item.flag"
            >
              <div class="packUp">展开处置结果</div>
              <span class="spa">
                <!-- <img src="../../../../assets/image/xiala.png" alt/> -->
              </span>
            </div>
            <div class="detail_li_showTime" v-show="!item.flag">
              <div
                class="viewTime line_bottom line_top"
                @click="showtipLine(item)"
              >
                查看部门时间轴
              </div>
              <div class="packUpBox">
                <div class="packUp" @click="item.flag = !item.flag">
                  收起处置结果
                </div>
                <span class="turn_top">
                  <!-- <img src="../../../../assets/image/xiala.png" alt /> -->
                </span>
              </div>

              <span class="turn_right">
                <img src="../../../../assets/image/t-right.png" alt />
              </span>
              <div></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <downIos></downIos> -->
  </div>
</template>
<script>
import api from "../../../../service/modules/complaintApis";
// import tipTimeLine from '../../views/detail/tipTimeLine';
import util from "../../../../utils/common";
import downIos from "./downIos";
export default {
  components: {
    downIos,
  },
  data() {
    return {
      headerFlag: true,
      menu: ["基本信息", "处置结果"],
      index: 0,
      flag: true,
      // item: this.$store.state.complaint.item,
      item: util.getJsonLocal("item"),
      showContent: true,
      success: true,
      timeList: "", // 时间轴数据
      // formData: {}, // 基本信息的数据
      detaiList: [], // 处置详情的数据
      unitType: "", // 判断是企业专用号或者政府专用号
      enterpriseFlag: false, // 企业号码隐藏
      groFlag: false, // 政府号码
      enterpriseFlag1: false, // 企业号码隐藏
      groFlag1: false, // 政府号码
      baseInfo: "",
      combinPhone: 0,
      sendInfo: "", // 上报后显示的上报机构
      oriList: "", // 转办后显示的机构
      splitInfo: "", // 拆单原因
      userInfo:
        this.$store.state.complaint.userInfo ||
        util.getJsonLocal("userInfoComplaint"),
      waitResponse: util.getJsonLocal("waitResponse") || "",
      sstt: ['ss1', 'ss2', 'ss3'],
    };
  },
  computed: {
    formData: {
      get() {
        return this.$store.state.complaint.basicImformation || {};
      },
      set(val) {
        this.$store.state.complaint.basicImformation = val;
      },
    },
  },
  watch: {
    flag(val) {
      if (val === 0) {
        this.flag = true;
      } else if (val === 1) {
        this.flag = false;
      }
    },
    formData(val) {
      this.baseInfo = val || {};
    },
  },
  mounted() {
    // this.$on('statusInfo', (val) => {
    //     this.sendInfo = val;
    // })
    // this.$on('getOriList', (val) => {
    //     this.oriList = val.transformationDetails;
    // })
    // this.$on('sendSplitInfo', (val) => {
    //     this.splitInfo = val.splitDetails;
    // })
  },
  created() {
    this.initData();
    this.getInfo();
    this.handleList();
  },
  methods: {
    downGazp(item) {
      console.log(item);
      var u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      if (isAndroid) {
        window.location.href = item;
      } else {
        this.$dispatch("downIosUrl", item);
        //  window.open(item, "_self");
      }

      // window.location.href=item;
    },
    initData() {
      //初始化数据
      // this.unitType = this.userInfo.userInfo.orgType;
      // if (this.unitType === 'enterprise') {
      //     this.enterpriseFlag = true;
      // } else {
      //     this.enterpriseFlag = false;
      // }
      const type = util.getJsonLocal("buttonType") || "";
      switch (type) {
        // case 'awaitReportlist'://上报待审核
        //       this.getReportDetails();
        //       break;
        // case 'notAcceptComplainList'://待响应
        //       this.getTransformationDetails();
        //       break;
        // case 'notHandleComplainList'://待处理
        //       this.getTransformationDetails();
        //       break;
        // case 'applySplitOrderList'://拆单待审核
        //       this.getSplitDetails();
        //       break;
        // case 'applyVerifyList'://申诉审核
        //       this.getApplyVerifyContent();
        //       break;
        case "reportIng": //上报待审核
          this.getReportDetails();
          break;
        case "centerAccepted": //待响应
          this.getTransformationDetails();
          break;
        case "depCompanyHandle": //待处理
          this.getTransformationDetails();
          break;
        case "centerHandle": //待处理
          this.getTransformationDetails();
          break;
        case "splitOrderReportIng": //拆单待审核
          this.getSplitDetails();
          break;
        case "appealReportIng": //申诉审核
          this.getApplyVerifyContent();
          break;
      }
    },
    getInfo() {
      //获取基本信息
      let params = {
        data: {
          mainComplainNumber: this.item.mainComplainNumber,
          complainNumber: this.item.complainNumber,
          type: "basicDetails",
          menuList: this.waitResponse,
          id: this.item.id,
          subId: this.item.subId,
          subPid: this.item.subPid,
        },
      };
      api.worker.detailInfo(params).then((res) => {
        if (res.ret === 0) {
          this.baseInfo = res.data.basicDetails;
          localStorage.setItem("info", JSON.stringify(res.data.basicDetails));
          // util.setJsonLocal('item',this.baseInfo);
          this.$store.commit("complaint/getbasicImformation", this.baseInfo);
        }
      });
    },
    handleList() {
      // 投诉处置详情
      let parms = {
        data: {
          mainComplainNumber: this.item.mainComplainNumber,
          type: "handleDetails",
        },
      };
      api.worker.detailInfo(parms).then((res) => {
        if (res.ret === 0) {
          if (res.data.handleDetails && res.data.handleDetails.length > 0) {
            res.data.handleDetails.map((item) => {
              item.flag = true;
            });
          }
          this.detaiList = res.data.handleDetails;
        }
      });
    },
    getPhone(type) {
      //获取手机号码
      let params = {
        data: {
          mainComplainNumber: this.item.mainComplainNumber,
          complainNumber: this.item.complainNumber,
          virtualNumberType: type,
          type: "virtualNumber",
        },
      };
      api.worker.detailInfo(params).then((res) => {
        console.log(res);
        if (res.ret === 0) {
          // this.getInfo();
          if (type === 0) {
            // 政府
            this.$set(this.baseInfo, "governmentVirtualNumber", res.data.phone);
          } else if (type === 1) {
            // 企业
            this.$set(this.baseInfo, "enterpriseVirtualNumber", res.data.phone);
          }
        }
      });
    },
    getReportDetails() {
      // 上报完了，详情多出的上报机构
      let parms = {
        data: {
          mainComplainNumber: this.item.mainComplainNumber,
          id: this.item.id,
          type: "reportDetails",
        },
      };
      api.worker.detailInfo(parms).then((res) => {
        console.log(res);
        if (res.ret === 0) {
          this.sendInfo = res.data;
          console.log(this.sendInfo, "0000---------");
          // this.$broadcast('statusInfo', res.data);
        }
      });
    },
    getTransformationDetails() {
      // 转办后需要显示的的转办机构
      let parms = {
        data: {
          mainComplainNumber: this.item.mainComplainNumber,
          id: this.item.id,
          type: "transformationDetails",
        },
      };
      api.worker.detailInfo(parms).then((res) => {
        if (res.ret === 0) {
          this.oriList = res.data.transformationDetails;
          // this.$broadcast('getOriList', res.data);
        }
      });
    },
    getSplitDetails() {
      // 拆单后需要显示的信息
      let parms = {
        data: {
          mainComplainNumber: this.item.mainComplainNumber,
          id: this.item.id,
          type: "splitDetails",
        },
      };
      api.worker.detailInfo(parms).then((res) => {
        console.log(res);
        if (res.ret === 0) {
          this.splitInfo = res.data.splitDetails;
          // this.$broadcast('sendSplitInfo', res.data);
        }
      });
    },
    getApplyVerifyContent() {
      // 申诉申请审核详情接口
      let parms = {
        data: {
          mainComplainNumber: this.item.mainComplainNumber,
          complainNumber: this.item.complainNumber,
          id: this.item.id,
          type: "applyVerifyContent",
        },
      };
      api.worker.detailInfo(parms).then((res) => {
        console.log(res);
        if (res.ret === 0) {
        }
      });
    },
    playPhone(value) {
      this.$dispatch("showCallPhone", value);
    },
    showViewer2(index, event, imgList) {
      let arr = [];
      imgList.map((item, index) => {
        arr.push(item.url);
      });
      this.$ImagePreview({
        images: arr,
        startPosition: index,
        closeOnPopstate: true,
      });
    },
    // 图片预览
    showViewer(index, event, imgList) {
      // window.yyn.invokeJSB(
      //       'openWindow', {
      //           openUrl: this.globalApp.getSystemInfo().host + 'web/#/complaint/imagesView?imageList='+imgList+'&index='+index,
      //           isFullScreen: 0,
      //           setTitle: '图片预览',
      //           needLoading: 1
      //       },
      //       cb => {
      //           console.log(cb, 'callback');
      //       }
      //   );
      // this.$router.push({
      //   path: '/complaint/imagesView',
      //   query: {
      //     imageList: imgList || [],
      //     index
      //   },
      // })
      this.$ImagePreview({
        images: imgList,
        startPosition: index,
        closeOnPopstate: true,
      });
      // this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
    },
    showViewer1(index, event, item) {
      // console.log(item);
      // console.log(index);
      // return;
      this.$router.push({
        path: "/complaint/imagesView",
        query: {
          imageList: item || [],
          index,
        },
      });
      // window.yyn.invokeJSB(
      //       'openWindow', {
      //           openUrl: this.globalApp.getSystemInfo().host + 'web/#/complaint/imagesView?imageList='+item.url+'&index='+index,
      //           isFullScreen: 0,
      //           setTitle: '图片预览',
      //           needLoading: 1
      //       },
      //       cb => {
      //           console.log(cb, 'callback');
      //       }
      //   );
      // this.$ImagePreview({ images: item.url, startPosition: index, closeOnPopstate: true });
    },
    showtipLine(item) {
      console.log(item, item.complainNumber, "----------");
      this.$dispatch("showTipe", item.complainNumber);
    },

    addClass(item, idx) {
      this.index = idx;
      this.flag = idx;
    },
    turnFlag() {
      this.showContent = !this.showContent;
    },
  },
  filters: {
    filt(value) {
      if (value) {
        return value.split("/")[value.split("/").length - 1];
      } else {
        return "Gazp";
      }
    },
    filt1(str) {
      let duration = str;
      let zero = function (times) {
        return times < 10 ? "0" + times : times;
      };
      let hour = zero(Math.floor(duration / 3600));
      let minutes = zero(Math.floor((duration / 60) % 60));
      let seconds = zero(Math.floor(duration % 60));
      let times = "";
      if (hour > 0) {
        times += hour + ":";
      } else {
        times += "00" + ":";
      }
      times += minutes + ":";
      times += seconds;

      return times;

      return times;
    },
    // 处理时长
    filt2(str) {
      let duration = str;
      let zero = function (times) {
        return times;
      };
      let hour = zero(Math.floor(duration / 3600));
      let minutes = zero(Math.ceil((duration / 60) % 60));
      let times = "";
      if (hour > 0) {
        times += hour + "小时";
      }
      times += minutes + "分钟";
      return times;
    },
    // 时长计算
    filt3(str) {
      let duration = str;
      let zero = function (times) {
        return times;
      };
      let hour = zero(Math.floor(duration / 3600));
      let minutes = zero(Math.ceil((duration / 60) % 60));
      let times = "";
      if (hour > 0) {
        times += hour + "小时";
      }
      times += minutes + "分钟";
      return times;
    },
  },
};
</script>
<style lang="less" scoped>
.title_color {
  color: #118bf5;
  margin-left: 6px;
}
.box1 {
  position: relative;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  background: #fafafa;
  overflow: hidden;
  padding-bottom: 20px;
  .detail {
    margin-left: 12px;
    padding-top: 16px;
    margin-right: 12px;
    background-color: #ffffff;
    // display: flex;
    // flex-direction: column;
    box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    .header {
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding-bottom: 8px;
      .header_title {
        width: 98px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #36b374;
        text-align: center;
        color: #36b374;
        background-color: #fbfbfb;
        font-size: 14px;
        &:nth-child(1) {
          border-right: none;
        }
      }
      .headerActive {
        background-color: #36b374;
        color: #ffffff;
      }
      .headerLeft {
        border-radius: 2px 0px 0px 2px;
      }
      .headerRight {
        border-radius: 0 2px 2px 0;
      }
    }
    .content2 {
      padding: 16px 0 16px 14px;
      .content_one {
        width: 100%;
        overflow: hidden;
        margin-bottom: 16px;
      }
      .content_reson {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 16px;
        align-items: flex-start;
      }
      .content_one_img {
        width: 100%;
        overflow: hidden;
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
      }
      .content_left {
        float: left;
        color: #999999;
        font-size: 14px;
        width: 70px;
        line-height: 18px;
        margin-right: 16px;
      }
      .content_icon {
        color: #36b374;
        line-height: 18px;
        font-size: 14px;
        width: 70%;
        float: left;
        display: flex;
        align-items: center;
      }
      .content_right {
        width: 70%;
        float: left;
        color: #333333;
        line-height: 18px;
        font-size: 14px;
        display: flex;
        align-items: center;
        .content_right_parent_content {
          float: left;
          color: #36b374;
        }
        .content_right_parent_img {
          float: left;
          margin-left: 8px;
          .content_right_img {
            width: 15px;
            height: 15px;
          }
        }
      }
      .content_right1 {
        line-height: 1.3em;
      }
      .content_img {
        width: 100%;
        padding-top: 10px;
        img {
          float: left;
          width: 74px;
          height: 74px;
          margin-right: 8px;
          margin-bottom: 8px;
          border-radius: 3px;
        }
      }
      .content_img1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 10px;
        .item {
          width: 33%;
          text-align: center;

          img {
            width: 50px;
            height: 50px;
            margin-right: 7px;
            margin-bottom: 8px;
            border-radius: 3px;
            display: inline-block;
          }
          .name {
            font-size: 14px;
            color: #999;
            width: 100%;
            overflow: hidden;
            white-space: normal;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .con_details {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .detail_top {
        padding: 16px 0 16px 14px;
        color: #999999;
        font-size: 14px;
        line-height: 22px;
        overflow: hidden;
        padding-right: 12px;
        // border-bottom: 1px solid #eeeeee;
        .detail_top_title {
          color: #333333;
          font-size: 14px;
          font-weight: 700;
          // line-height: 22px;
          // padding-bottom: 8px;
          .special {
            display: inline-block;
            color: #999999;
            font-weight: 300;
            font-size: 12px;
            margin-left: 8px;
          }
        }
      }
      .detail_list {
        overflow: hidden;
        .detail_li {
          border-bottom: 1px solid #eeeeee;
          .detail_li_top {
            // margin-top: 15px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            overflow: hidden;
            padding-right: 14px;
            .detail_li_title {
              // display: inline-block;
              // vertical-align: middle;
              float: left;
              color: #333333;
              padding-left: 14px;
              line-height: 14px;
              width: 68%;
              font-size: 14px;
              margin-top: 16px;
              font-weight: 800;
            }
            .detail_li_title_tag {
              margin-top: 16px;
              border: 1px solid #118bf5;
              padding: 4px 8px;
              border-radius: 16px;
              background: #118bf5;
              color: #fff;
            }
            .ss1 {
              background: #118bf5;
              border: 1px solid #118bf5;
            }
            .ss2 {
              background: #ffa509;
              border: 1px solid #ffa509;
            }
            .ss3 {
              background: #f75c32;
              border: 1px solid #f75c32;
            }
            .detail_li_button {
              // display: inline-block;
              // vertical-align: middle;
              float: left;
              overflow: hidden;
              // margin-top: 13px;
              .btn {
                display: inline-block;
                width: 44px;
                height: 18px;
                line-height: 20px;
                color: #ff4d4d;
                border: 1px solid #ff4d4d;
                text-align: center;
                font-size: 12px;
                border-radius: 10px;
                margin-right: 10px;
              }
              .btn1 {
                display: inline-block;
                width: 44px;
                height: 18px;
                background: #ffffff;
                border-radius: 10px;
              }
              .ordinary {
                display: inline-block;
                width: 44px;
                height: 20px;
                line-height: 20px;
                color: #ffffff;
                text-align: center;
                font-size: 12px;
                border-radius: 10px;
                background-color: #118bf5;
              }
              .discharge {
                display: inline-block;
                width: 44px;
                height: 20px;
                line-height: 20px;
                color: #ffffff;
                text-align: center;
                font-size: 12px;
                border-radius: 10px;
                background-color: #ffa000;
              }
              .serious {
                display: inline-block;
                width: 44px;
                height: 20px;
                line-height: 20px;
                color: #ffffff;
                text-align: center;
                font-size: 12px;
                border-radius: 10px;
                background-color: #ff4d17;
              }
            }
          }
          .detail_li_content {
            color: #999999;
            padding: 6px 16px 16px 14px;
            line-height: 26px;
            font-size: 14px;
            overflow: hidden;
            .detail_li_content_one {
              .detail_li_content_left {
                float: left;
                width: 50%;
              }
              .detail_li_content_right {
                float: left;
                width: 50%;
                overflow: hidden;
              }
            }
            .content_img {
              width: 100%;
              padding-top: 10px;

              img {
                float: left;
                width: 74px;
                height: 74px;
                margin-right: 8px;
                margin-bottom: 8px;
                border-radius: 3px;
              }
            }
          }
          .detail_li_result {
            overflow: hidden;
            color: #999999;
            // margin-top: 16px;
            padding: 0 12px 0 12px;
            font-size: 14px;
            .detail_li_content_score {
              display: flex;
              flex-direction: row;
              align-items: center;
              img {
                width: 20px;
                height: 20px;
              }
            }
            .detail_li_result_top {
              width: 100%;
              overflow: hidden;
              line-height: 30px;
              .detail_li_result_top_left {
                float: left;
                // color:#333;
              }
              .detail_li_result_success {
                color: #118bf5;
              }
              .detail_li_result_defeated {
                color: #ff4d4d;
              }
              .detail_li_result_name {
                color: #4a4a4a;
              }
              .detail_li_result_top_right {
                float: right;
                // color:#333;
              }
            }
            .detail_li_result_content {
              width: 100%;
              display: flex;
              flex-direction: row;
              align-content: center;
              flex-wrap: wrap;
              i {
                display: block;
                word-break: break-all;
                line-height: 22px;
              }
            }
            .content_img {
              overflow: hidden;
              width: 100%;
              padding-top: 10px;
              .file_img {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                word-break: break-all;
                span:nth-child(1) {
                  width: 80%;
                }
              }
              img {
                float: left;
                width: 74px;
                height: 74px;
                margin-right: 7px;
                margin-bottom: 8px;
                border-radius: 3px;
              }
            }
          }
          .detail_li_returnResult {
            // margin-top: 10px;
            position: relative;
            line-height: 26px;
            font-size: 14px;
            color: #333333;
            width: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            .spa {
              width: 0px;
              height: 0px;
              border: 3.5px solid #c8c9cc;
              margin-top: 3px;
              margin-left: 5px;
              border-bottom-color: transparent;
              border-left-color: transparent;
              border-right-color: transparent;
            }
            .packUp {
              line-height: 45px;
              // border-bottom: 1px solid #eeeeee;
            }
          }
          .detail_li_showTime {
            margin-top: 10px;
            position: relative;
            line-height: 26px;
            font-size: 14px;
            color: #333333;
            width: 100%;
            text-align: center;
            .viewTime {
              padding: 0 12px;
              text-align: center;
              // border: 1px solid #eeeeee;
              border-left: none;
              border-right: none;
              line-height: 45px;
            }
            .packUpBox {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              .packUp {
                line-height: 45px;
                // border-bottom: 1px solid #eeeeee;
              }
              .turn_top {
                width: 0px;
                height: 0px;
                border: 3.5px solid #c8c9cc;
                margin-left: 5px;
                margin-bottom: 4px;
                transform: rotate(180deg);
                border-bottom-color: transparent;
                border-left-color: transparent;
                border-right-color: transparent;
              }
            }

            .turn_right {
              position: absolute;
              width: 12px;
              height: 12px;
              left: 328px;
              top: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
